import LogoPNG from "../../../assets/images/logo-full.png"
export const Logo: React.FC = () => {
  return (
    <img src={LogoPNG} alt="" className="w-[142px] h-[194px]" />
  )
}
